var AdventureactivityConst = {
    Ground_Type: {
        adventure: 1, //冒险
        element: 2, //元素
        heaven: 3,  // 天界副本
    },

    //  红点类型
    Red_Type: {
        adventure: 1, //冒险
        element: 2, //元素
        heaven: 3, // 天界副本
    }
    
}

module.exports = AdventureactivityConst